import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const ACCION_LABELS = {
  crear: "Creó", editar: "Editó", marcar_cobrado: "Marcó cobrado", marcar_pagado: "Marcó pagado",
  invalidar: "Invalidó", anular_costo: "Anuló costo", desbloquear: "Desbloqueó", bloquear: "Bloqueó",
  confirmar_referencia_repetida: "Confirmó ref. repetida", revertir_pago: "Revirtió pago", revertir_cobro: "Revirtió cobro",
};

export function ReporteActividad({ data }) {
  const items = data?.items || [];
  const acciones = Array.from(new Set(items.flatMap((r) => Object.keys(r.acciones || {})))).sort();
  return (
    <div>
      <p className="mb-3 text-sm text-muted-foreground" data-testid="reporte-actividad-total">
        {data?.total_eventos ?? 0} eventos de auditoría en el período
        {data?.truncado && <span className="ml-2 text-amber-600">— resultado truncado, exportá a Excel para verlo completo</span>}
      </p>
      <Table data-testid="reporte-actividad-table">
        <TableHeader>
          <TableRow>
            <TableHead>Usuario</TableHead>
            {acciones.map((a) => <TableHead key={a} className="text-right">{ACCION_LABELS[a] || a}</TableHead>)}
            <TableHead className="text-right">Total</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {items.map((r) => (
            <TableRow key={r.usuario} data-testid={`reporte-actividad-row-${r.usuario}`}>
              <TableCell>{r.usuario}</TableCell>
              {r.acciones ? acciones.map((a) => <TableCell key={a} className="text-right">{r.acciones[a] || 0}</TableCell>) : null}
              <TableCell className="text-right font-semibold">{r.total}</TableCell>
            </TableRow>
          ))}
          {items.length === 0 && (
            <TableRow><TableCell colSpan={acciones.length + 2} className="text-center text-sm text-muted-foreground py-8">Sin actividad en el período.</TableCell></TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
}
